import { connect } from 'react-redux';
import BaseForm from '../BaseForm/BaseForm';
import { showError, clearErrors } from '../../redux/actions/bookings';
import * as validator from 'validator';

class BookingAssignForm extends BaseForm {
  constructor(props) {
    super(props, {
      name: 'Vehicle',
      action: 'Assign',
      type: 'update',
      onChange: props.onChange,
      onSubmit: props.onSubmit,
    });
  }

  handleValidate(data) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    const throwError = (message) => {
      this.props.dispatch(showError(message));
      return false;
    };
    if (isNaN(Number(data.vehicle_id))) {
      return throwError('Please select a vehicle');
    }
    if (validator.isEmpty(String(data.mileage))) {
      return throwError('Mileage can not be empty');
    }
    if (!validator.isNumeric(String(data.mileage))) {
      return throwError('Mileage must be numeric');
    }
    return data;
  }

  handleReset(dispatch, actions) {
  }
}

const mapStateToProps = ({ bookings }) => ({
  model: bookings,
  fields: BaseForm.fields.bookings.assign,
});

export default connect(mapStateToProps)(BookingAssignForm);
